import axios from 'axios';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning, faCircleChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "../../../scss/Components/_modal.scss"
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { toast } from 'react-toastify';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';

function ModalAllQDelete(props) {
    const {
        qModalDeleteString,
        qModalDeleteQNameString,
        qModalDeleteQDescString,
        modalYesString,
        modalNoString,
    } = useTranslationHook();

    var deleteQName = localStorage.getItem("qNameToDelete");
    var deleteQDesc = localStorage.getItem("qDescToDelete");

    var deleteQId = localStorage.getItem("qIdForDelete");
    
    function deleteQ() {
        customAxios.request({
            url: `${GlobalVariables.getURL()}deleteQT/${deleteQId}`,
            method: 'delete',
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        }).then((response) => {
            console.log(response.data)
            hideS();
        }, (error) => {
            console.log(error);
            getToast({ status: 'error', title: 'Error al eliminar cuestionario. Vuelve a intentarlo.' });
        });
    };
    
    function hideS(){
        props.onHide();
        getToast({ status: 'success', title: 'Cuestionario eliminado exitosamente en la base de datos.' });
        props.getQuestionnaires();
    }

    function hideN(){
        props.onHide();
    }
  
    return (
        <Modal 
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName="modal-backdrop"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
                    {qModalDeleteString}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span className='delete-info'><strong>{qModalDeleteQNameString}:</strong> {deleteQName}</span><br />
                <span className='delete-info'><strong>{qModalDeleteQDescString}:</strong> {deleteQDesc}</span><br />
            </Modal.Body>
            <Modal.Footer>
                <button className='modal-button' onClick={() => {deleteQ()}}><FontAwesomeIcon icon={faWarning}/> {modalYesString}</button>
                <button className='modal-button no' onClick={() => {hideN()}}><FontAwesomeIcon icon={faCircleChevronLeft}/> {modalNoString}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalAllQDelete;